import { ApolloClient } from "@apollo/client/core";
import { gql } from "graphql-tag";
import pick from "lodash/pick";

import { transformCamelToSnake } from "lib/stringFunctions";
import { UserBookSerializersUserBook } from "types/serializers";

import { editFields } from "../constants";

const updateUserBookQuery = gql`
  mutation UpdateUserBook($id: Int!, $object: UserBookUpdateInput!) {
    updateResponse: update_user_book(id: $id, object: $object) {
      error
      userBook: user_book {
        ...UserBookFragment
      }
    }
  }
`;

export async function updateUserBook({
  client,
  id,
  userBook,
  userDate,
}: {
  client: ApolloClient<any>;
  id: number;
  userBook: UserBookSerializersUserBook;
  userDate?: string;
}): Promise<UserBookSerializersUserBook> {
  const objectData = pick(transformCamelToSnake(userBook), editFields);

  if (userDate) {
    objectData.user_date = userDate;
  }

  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: updateUserBookQuery,
        variables: {
          id,
          object: objectData,
        },
      })
      .then(result => {
        if (result.data.updateResponse.error) {
          reject(result.data.updateResponse.error);
        } else {
          resolve(result.data.updateResponse.userBook);
        }
      })
      .catch(e => {
        reject(e.message);
      });
  });
}
